<template>
  <div class="ob">

    <!-- Progress dots -->
    <div class="ob__progress">
      <div v-for="n in totalSlides" :key="n" class="ob__dot"
           :class="{ 'ob__dot--active': currentSlide === n }" @click="goTo(n)" />
    </div>

    <!-- Stage -->
    <div class="ob__stage">

      <!-- ── 1 · Portada ──────────────────────────────────────────── -->
      <div v-if="currentSlide === 1" class="ob__slide ob__slide--center">
        <svg class="ob__logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 436.722 196.02" aria-label="Inqi">
          <g transform="translate(-181.639 -301.99)" fill="#fff">
            <path d="M200.442,323.826a18.578,18.578,0,1,1,18.579,18.58,18.578,18.578,0,0,1-18.579-18.58"/>
            <path d="M242.222,363.76c-.627-4.154-3.625-14.423-17.971-14.423h-1.5c-2.2.039-4.938.278-5,.284l-30.847,2.936a4.942,4.942,0,0,0-1.969.822c-.08.065-.133.139-.207.207a4.5,4.5,0,0,0-1.3,2.031,9.119,9.119,0,0,0-.417,1.358c0,.017-.012.023-.012.044,0,.006,0,.006,0,.015s-.017.088-.017.088l-1.34,16.475-.009.568a3.312,3.312,0,0,0,.991,2.365,3.357,3.357,0,0,0,2.365,1.017l17.731-1.836a4.185,4.185,0,0,1,4.586,3.743l6.091,61c.751,4.6,4.21,14.987,20.283,15.162,14.023.153,16.365-8.152,16.427-13.5Z"/>
            <path d="M336.106,377.23q-4.62-3.738-12.321-3.74a33.57,33.57,0,0,0-9.679,1.32,44.848,44.848,0,0,0-8.14,3.3v77.88a43.541,43.541,0,0,1-6.16,1.21,64.762,64.762,0,0,1-8.8.55q-9.9,0-14.3-3.19t-4.4-12.431V374.15a16,16,0,0,1,2.42-9.24,26.743,26.743,0,0,1,6.82-6.6q7.038-5.058,18.15-8.14a91.712,91.712,0,0,1,24.531-3.08q23.976,0,37.068,10.56t13.092,30.14v68.2a53.11,53.11,0,0,1-6.381,1.21,64.767,64.767,0,0,1-8.8.55q-9.9,0-14.189-3.19t-4.289-12.431v-53.46Q340.727,380.972,336.106,377.23Z"/>
            <path d="M501.545,496.03a52.347,52.347,0,0,1-6.271,1.32,54.315,54.315,0,0,1-8.689.66q-9.9,0-14.3-3.3t-4.4-12.54V456.43a55.533,55.533,0,0,1-8.691,2.2,59.83,59.83,0,0,1-10.449.88,64.675,64.675,0,0,1-21.78-3.519,45.966,45.966,0,0,1-28.49-27.941,67.575,67.575,0,0,1-4.069-24.42q0-14.074,4.289-24.639a47.186,47.186,0,0,1,12.1-17.6,52.163,52.163,0,0,1,18.7-10.67,76.575,76.575,0,0,1,24.309-3.63,82.2,82.2,0,0,1,22.55,2.97q10.447,2.97,16.17,6.71a21.929,21.929,0,0,1,6.71,6.49,17.154,17.154,0,0,1,2.311,9.35Zm-47.96-63.14a28.056,28.056,0,0,0,14.519-3.74V376.79a39.927,39.927,0,0,0-5.719-2.2,26.561,26.561,0,0,0-7.92-1.1q-11.88,0-18.92,7.37t-7.04,22.769q0,15.182,6.6,22.221T453.585,432.89Z"/>
            <path d="M525.744,320.03a17.57,17.57,0,0,1,5.17-12.76q5.166-5.28,13.529-5.28t13.53,5.28a17.582,17.582,0,0,1,5.17,12.76,17.841,17.841,0,0,1-5.17,12.98q-5.171,5.28-13.53,5.28t-13.529-5.28A17.829,17.829,0,0,1,525.744,320.03Zm35.42,135.96A43.571,43.571,0,0,1,555,457.2a64.774,64.774,0,0,1-8.8.55q-9.9,0-14.191-3.19t-4.29-12.431V351.71a52.8,52.8,0,0,1,6.161-1.32,53.732,53.732,0,0,1,8.8-.66q9.9,0,14.191,3.3t4.29,12.54Z"/>
            <path d="M579.2,439.93a20.23,20.23,0,0,1,5.17-14.08q5.166-5.718,14.41-5.721,9.018,0,14.3,5.721a21.412,21.412,0,0,1,0,28.159q-5.28,5.719-14.3,5.721-9.24,0-14.41-5.721A20.214,20.214,0,0,1,579.2,439.93Z"/>
          </g>
        </svg>
        <h1 class="ob__hero-title">Bienvenido a Inqi</h1>
        <p class="ob__hero-lead">Tu panel de administración de rentas e inquilinos. Te mostramos cómo usar cada módulo paso a paso.</p>
        <button class="ob__cta" @click="next">Empezar</button>
      </div>

      <!-- ── 2 · El inicio ───────────────────────────────────────── -->
      <div v-if="currentSlide === 2" class="ob__slide ob__slide--duo">
        <div class="ob__col-text">
          <div class="ob__path"><span class="ob__path-item ob__path-item--active">Dashboard</span></div>
          <span class="ob__num">02 · El inicio</span>
          <h2 class="ob__heading">Lo que necesitas atender hoy, en un vistazo.</h2>
          <div class="ob__line" />
          <p class="ob__lead">Al entrar al panel (opción <strong>Dashboard</strong> en el menú), verás todo lo que tiene vencimientos pendientes, agrupado por tipo. Cada sección es colapsable.</p>
          <div class="ob__table-wrap">
            <table class="ob__table">
              <thead><tr><th>Sección</th><th>Aparece cuando…</th><th>Badge</th></tr></thead>
              <tbody>
                <tr><td>Contratos por renovar</td><td>La fecha de fin del contrato es dentro de 30 días o ya pasó</td><td><span class="ob__badge ob__badge--warning">Por vencer</span> <span class="ob__badge ob__badge--error">Vencido</span></td></tr>
                <tr><td>Rentas pendientes</td><td>La fecha de vencimiento de la letra ya pasó y no está pagada</td><td><span class="ob__badge ob__badge--error">Atrasada</span></td></tr>
                <tr><td>Impuestos pendientes</td><td>El vencimiento del impuesto ya pasó y no está pagado</td><td><span class="ob__badge ob__badge--error">Atrasado</span></td></tr>
                <tr><td>Prediales pendientes</td><td>El vencimiento del predial ya pasó y no está pagado</td><td><span class="ob__badge ob__badge--error">Atrasado</span></td></tr>
                <tr><td>Arbitrios pendientes</td><td>El vencimiento del arbitrio ya pasó y no está pagado</td><td><span class="ob__badge ob__badge--error">Atrasado</span></td></tr>
              </tbody>
            </table>
          </div>
          <div class="ob__tip">El <strong>Dashboard</strong> solo muestra lo que ya está atrasado. Para ver todas las letras sin pagar ve a <strong>Recaudación → Ver todas las letras pendientes</strong>.</div>
        </div>
        <div class="ob__col-screen">
          <div class="ob__screen"><img src="/onboarding/01-dashboard.png" alt="Dashboard" /></div>
        </div>
      </div>

      <!-- ── 3 · Recaudación ─────────────────────────────────────── -->
      <div v-if="currentSlide === 3" class="ob__slide ob__slide--duo">
        <div class="ob__col-text">
          <div class="ob__path"><span class="ob__path-item ob__path-item--active">Recaudación</span></div>
          <span class="ob__num">03 · Recaudación</span>
          <h2 class="ob__heading">El pulso del mes.</h2>
          <div class="ob__line" />
          <p class="ob__lead">En <strong>Recaudación</strong> (menú lateral) ves cuánto se esperaba cobrar, cuánto se cobró y cuánto queda pendiente — para el mes que elijas, desglosado por propiedad.</p>
          <div class="ob__cards">
            <div class="ob__card">
              <div class="ob__card-icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg></div>
              <div><p class="ob__card-title">Navega por mes y año</p><p class="ob__card-body">Usa los selectores del encabezado para revisar cualquier período histórico.</p></div>
            </div>
            <div class="ob__card">
              <div class="ob__card-icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg></div>
              <div><p class="ob__card-title">Porcentaje por propiedad</p><p class="ob__card-body">Cada local muestra su avance. Verde = al día, rojo = mora.</p></div>
            </div>
            <div class="ob__card">
              <div class="ob__card-icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg></div>
              <div><p class="ob__card-title">Detalle por inquilino</p><p class="ob__card-body">Cada tarjeta de propiedad desglosa el estado de pago de cada inquilino.</p></div>
            </div>
            <div class="ob__card">
              <div class="ob__card-icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg></div>
              <div><p class="ob__card-title">Registrar pagos sin salir</p><p class="ob__card-body">Desde <strong>Ver todas las letras pendientes</strong> puedes pagar cualquier letra directamente.</p></div>
            </div>
          </div>
        </div>
        <div class="ob__col-screen">
          <div class="ob__screen"><img src="/onboarding/02-recaudacion.png" alt="Recaudación" /></div>
        </div>
      </div>

      <!-- ── 4 · Propiedades ─────────────────────────────────────── -->
      <div v-if="currentSlide === 4" class="ob__slide ob__slide--duo">
        <div class="ob__col-text">
          <div class="ob__path"><span class="ob__path-item ob__path-item--active">Propiedades</span><span class="ob__path-sep">›</span><span class="ob__path-item">Nueva propiedad</span></div>
          <span class="ob__num">04 · Propiedades</span>
          <h2 class="ob__heading">El primer paso antes de registrar inquilinos.</h2>
          <div class="ob__line" />
          <p class="ob__lead">En <strong>Propiedades</strong> (menú lateral) registras los locales físicos que administras. Cada inquilino se asigna a una propiedad. Sin propiedades no puedes dar de alta inquilinos.</p>
          <div class="ob__table-wrap">
            <table class="ob__table">
              <thead><tr><th>Campo</th><th>Req.</th><th>Notas</th></tr></thead>
              <tbody>
                <tr><td>Descripción</td><td><span class="ob__req">✓</span></td><td>Nombre del local. Ej: Local A-12 Galería Gamarra</td></tr>
                <tr><td>M2</td><td><span class="ob__req">✓</span></td><td>Metros cuadrados (número entero)</td></tr>
                <tr><td>Dirección</td><td><span class="ob__req">✓</span></td><td></td></tr>
                <tr><td>Propietario</td><td><span class="ob__req">✓</span></td><td>Persona o empresa dueña del local</td></tr>
                <tr><td>Provincia</td><td><span class="ob__req">✓</span></td><td>Se guarda en mayúsculas automáticamente</td></tr>
                <tr><td>Distrito</td><td><span class="ob__req">✓</span></td><td>Se guarda en mayúsculas automáticamente</td></tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="ob__col-screen">
          <div class="ob__screen"><img src="/onboarding/07-propiedades.png" alt="Propiedades" /></div>
        </div>
      </div>

      <!-- ── 5 · Inquilinos ──────────────────────────────────────── -->
      <div v-if="currentSlide === 5" class="ob__slide ob__slide--duo">
        <div class="ob__col-text">
          <div class="ob__path"><span class="ob__path-item ob__path-item--active">Inquilinos</span><span class="ob__path-sep">›</span><span class="ob__path-item">Nuevo inquilino</span></div>
          <span class="ob__num">05 · Inquilinos</span>
          <h2 class="ob__heading">Registra los datos y condiciones de pago.</h2>
          <div class="ob__line" />
          <p class="ob__lead">En <strong>Inquilinos</strong> (menú lateral) están todos tus arrendatarios. Al crear uno nuevo se le asigna una propiedad y se definen sus condiciones base.</p>
          <div class="ob__table-wrap">
            <table class="ob__table">
              <thead><tr><th>Campo</th><th>Req.</th><th>Notas</th></tr></thead>
              <tbody>
                <tr><td>Propiedad</td><td><span class="ob__req">✓</span></td><td>Seleccionas de las propiedades registradas</td></tr>
                <tr><td>Nombre</td><td><span class="ob__req">✓</span></td><td>Razón social o nombre legal completo</td></tr>
                <tr><td>Alias</td><td><span class="ob__req">✓</span></td><td>Nombre corto para búsquedas</td></tr>
                <tr><td>Tipo de documento</td><td><span class="ob__req">✓</span></td><td>RUC o DNI</td></tr>
                <tr><td>Documento</td><td><span class="ob__req">✓</span></td><td>11 dígitos para RUC, 8 para DNI</td></tr>
                <tr><td>Email</td><td><span class="ob__req">✓</span></td><td>Si creas acceso a la app, este será su usuario de login</td></tr>
                <tr><td>Celular</td><td><span class="ob__opt">—</span></td><td>Opcional, campo libre</td></tr>
                <tr><td>Día de pago</td><td><span class="ob__req">✓</span></td><td>Del 1 al 31. Determina el vencimiento de cada letra</td></tr>
                <tr><td>Metros cuadrados</td><td><span class="ob__req">✓</span></td><td>Número entero</td></tr>
                <tr><td>Método de pago</td><td><span class="ob__req">✓</span></td><td>Efectivo · Depósito · Cheque · Transferencia</td></tr>
                <tr><td>Observación</td><td><span class="ob__req">✓</span></td><td>Notas internas (puede ser un guión "-")</td></tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="ob__col-screen">
          <div class="ob__screen"><img src="/onboarding/03-inquilinos.png" alt="Inquilinos" /></div>
        </div>
      </div>

      <!-- ── 6 · Cómo se relaciona todo ─────────────────────────── -->
      <div v-if="currentSlide === 6" class="ob__slide ob__slide--wide">
        <div class="ob__path"><span class="ob__path-item ob__path-item--active">Inquilinos</span><span class="ob__path-sep">›</span><span class="ob__path-item">un inquilino</span></div>
        <span class="ob__num">06 · Cómo se relaciona todo</span>
        <h2 class="ob__heading">Cada inquilino tiene tres pestañas.</h2>
        <div class="ob__line" />
        <p class="ob__lead">Al hacer clic en un inquilino en <strong>Inquilinos</strong>, entras a su ficha con tres pestañas: <strong>Letras</strong>, <strong>Impuestos</strong> y <strong>Contratos</strong>. El orden de trabajo siempre es el mismo.</p>
        <div class="ob__flow">
          <div class="ob__flow-step"><span class="ob__flow-num">1</span><div><p class="ob__flow-title">Propiedades</p><p class="ob__flow-desc">Los locales físicos. Cada inquilino se asigna a uno.</p></div></div>
          <div class="ob__flow-arrow">↓</div>
          <div class="ob__flow-step"><span class="ob__flow-num">2</span><div><p class="ob__flow-title">Inquilinos</p><p class="ob__flow-desc">Datos del arrendatario y condiciones de pago.</p></div></div>
          <div class="ob__flow-arrow">↓</div>
          <div class="ob__flow-step"><span class="ob__flow-num">3</span><div><p class="ob__flow-title">Pestaña Contratos → Agregar contrato</p><p class="ob__flow-desc">Define la renta, moneda y vigencia. El sistema actualiza el perfil automáticamente.</p></div></div>
          <div class="ob__flow-arrow">↓</div>
          <div class="ob__flow-step"><span class="ob__flow-num">4</span><div><p class="ob__flow-title">Pestaña Letras → Generar letras</p><p class="ob__flow-desc">Crea todas las letras del período de una vez.</p></div></div>
          <div class="ob__flow-arrow">↓</div>
          <div class="ob__flow-step"><span class="ob__flow-num">5</span><div><p class="ob__flow-title">Pestaña Letras → Registrar pago</p><p class="ob__flow-desc">Cada mes, al cobrar, registras el pago con fecha y comprobante.</p></div></div>
        </div>
      </div>

      <!-- ── 7 · Contratos ───────────────────────────────────────── -->
      <div v-if="currentSlide === 7" class="ob__slide ob__slide--duo">
        <div class="ob__col-text">
          <div class="ob__path"><span class="ob__path-item ob__path-item--active">Inquilinos</span><span class="ob__path-sep">›</span><span class="ob__path-item">un inquilino</span><span class="ob__path-sep">›</span><span class="ob__path-item">Contratos</span></div>
          <span class="ob__num">07 · Contratos</span>
          <h2 class="ob__heading">Define la renta antes de generar letras.</h2>
          <div class="ob__line" />
          <p class="ob__lead">El contrato establece cuánto paga el inquilino por mes, en qué moneda y durante qué período. Al guardar uno, el sistema actualiza automáticamente la renta en el perfil del inquilino.</p>
          <div class="ob__states">
            <div class="ob__state"><span class="ob__badge ob__badge--success">Activo</span><p>La fecha de fin aún no llega. Este contrato define la renta actual.</p></div>
            <div class="ob__state"><span class="ob__badge ob__badge--error">Vencido</span><p>La fecha de fin ya pasó. El sistema lo marca automáticamente. Queda como historial.</p></div>
          </div>
          <div class="ob__table-wrap">
            <table class="ob__table">
              <thead><tr><th>Campo</th><th>Req.</th><th>Notas</th></tr></thead>
              <tbody>
                <tr><td>Inicio de contrato</td><td><span class="ob__req">✓</span></td><td></td></tr>
                <tr><td>Fin de contrato</td><td><span class="ob__req">✓</span></td><td>Para contratos indefinidos usa una fecha lejana (ej: 31/12/2099)</td></tr>
                <tr><td>Moneda</td><td><span class="ob__req">✓</span></td><td>Soles o Dólares</td></tr>
                <tr><td>Renta mensual</td><td><span class="ob__req">✓</span></td><td>Se usa para calcular el monto de las letras</td></tr>
                <tr><td>Garantía</td><td><span class="ob__req">✓</span></td><td>Depósito en garantía — informativo</td></tr>
                <tr><td>Contrato PDF</td><td><span class="ob__opt">—</span></td><td>Opcional. Se sube como respaldo</td></tr>
              </tbody>
            </table>
          </div>
          <div class="ob__tip">Para renovar un contrato, crea uno nuevo con la nueva renta y fechas. No edites el anterior — el historial es importante.</div>
        </div>
        <div class="ob__col-screen">
          <div class="ob__screen"><img src="/onboarding/05-contratos.png" alt="Contratos" /></div>
        </div>
      </div>

      <!-- ── 8 · Letras ──────────────────────────────────────────── -->
      <div v-if="currentSlide === 8" class="ob__slide ob__slide--duo">
        <div class="ob__col-text">
          <div class="ob__path"><span class="ob__path-item ob__path-item--active">Inquilinos</span><span class="ob__path-sep">›</span><span class="ob__path-item">un inquilino</span><span class="ob__path-sep">›</span><span class="ob__path-item">Letras</span></div>
          <span class="ob__num">08 · Letras</span>
          <h2 class="ob__heading">El recibo de renta de cada mes.</h2>
          <div class="ob__line" />
          <p class="ob__lead">Una letra es el cobro mensual de un inquilino. Tiene un monto, una fecha de vencimiento y un estado: <strong>Pendiente</strong> o <strong>Pagada</strong>. Las letras atrasadas (vencidas sin pagar) aparecen en el <strong>Dashboard</strong>.</p>
          <p class="ob__section-title">Generar letras</p>
          <div class="ob__table-wrap">
            <table class="ob__table">
              <thead><tr><th>Campo</th><th>Req.</th><th>Notas</th></tr></thead>
              <tbody>
                <tr><td>Cantidad de letras</td><td><span class="ob__req">✓</span></td><td>Número de meses. 12 = un año completo</td></tr>
                <tr><td>¿Incluir este mes?</td><td><span class="ob__req">✓</span></td><td>Sí → primera letra vence este mes. No → empieza el mes siguiente</td></tr>
              </tbody>
            </table>
          </div>
          <p class="ob__section-title">Registrar pago</p>
          <div class="ob__table-wrap">
            <table class="ob__table">
              <thead><tr><th>Campo</th><th>Req.</th><th>Notas</th></tr></thead>
              <tbody>
                <tr><td>Fecha de pago</td><td><span class="ob__req">✓</span></td><td>La fecha real en que recibiste el pago</td></tr>
                <tr><td>Observación</td><td><span class="ob__opt">—</span></td><td>Notas internas: "pagó en efectivo", etc.</td></tr>
                <tr><td>Comprobantes</td><td><span class="ob__opt">—</span></td><td>Imágenes del recibo. Puedes subir varios</td></tr>
              </tbody>
            </table>
          </div>
          <div class="ob__tip">Si el inquilino tiene acceso a la app, puede subir su comprobante desde el celular. Esa imagen aparece antes de que registres el pago, pero <strong>no confirma el pago automáticamente</strong>.</div>
        </div>
        <div class="ob__col-screen">
          <div class="ob__screen"><img src="/onboarding/04-detalle-letras.png" alt="Letras" /></div>
        </div>
      </div>

      <!-- ── 9 · Impuestos del inquilino ─────────────────────────── -->
      <div v-if="currentSlide === 9" class="ob__slide ob__slide--duo">
        <div class="ob__col-text">
          <div class="ob__path"><span class="ob__path-item ob__path-item--active">Inquilinos</span><span class="ob__path-sep">›</span><span class="ob__path-item">un inquilino</span><span class="ob__path-sep">›</span><span class="ob__path-item">Impuestos</span></div>
          <span class="ob__num">09 · Impuestos del inquilino</span>
          <h2 class="ob__heading">Cobros adicionales a la renta mensual.</h2>
          <div class="ob__line" />
          <p class="ob__lead">En la pestaña <strong>Impuestos</strong> del detalle de un inquilino registras los tributos que le corresponden pagar. Son independientes de la renta mensual.</p>
          <div class="ob__table-wrap">
            <table class="ob__table">
              <thead><tr><th>Campo</th><th>Req.</th><th>Notas</th></tr></thead>
              <tbody>
                <tr><td>Total</td><td><span class="ob__req">✓</span></td><td>Pre-cargado con el 5 % de la renta. Editable</td></tr>
                <tr><td>Fecha de vencimiento</td><td><span class="ob__req">✓</span></td><td></td></tr>
              </tbody>
            </table>
          </div>
          <div class="ob__tip">Registrar el pago de un impuesto funciona igual que el de una letra: fecha de pago obligatoria, observación y comprobantes opcionales.</div>
        </div>
        <div class="ob__col-screen">
          <div class="ob__screen"><img src="/onboarding/06-impuestos-inquilino.png" alt="Impuestos del inquilino" /></div>
        </div>
      </div>

      <!-- ── 10 · Prediales y arbitrios ─────────────────────────── -->
      <div v-if="currentSlide === 10" class="ob__slide ob__slide--duo">
        <div class="ob__col-text">
          <div class="ob__path"><span class="ob__path-item ob__path-item--active">Propiedades</span><span class="ob__path-sep">›</span><span class="ob__path-item">una propiedad</span><span class="ob__path-sep">›</span><span class="ob__path-item">Impuestos prediales</span></div>
          <span class="ob__num">10 · Prediales y arbitrios</span>
          <h2 class="ob__heading">Los tributos del local, no del inquilino.</h2>
          <div class="ob__line" />
          <p class="ob__lead">En <strong>Propiedades</strong> (menú lateral), al hacer clic en una propiedad, puedes gestionar sus impuestos prediales y arbitrios. Son tributos del local en sí, independientes de quién lo arrienda.</p>
          <div class="ob__table-wrap">
            <table class="ob__table">
              <thead><tr><th>Campo</th><th>Req.</th><th>Notas</th></tr></thead>
              <tbody>
                <tr><td>Tipo</td><td><span class="ob__req">✓</span></td><td>Predial o Arbitrio</td></tr>
                <tr><td>Moneda</td><td><span class="ob__req">✓</span></td><td>Soles o Dólares</td></tr>
                <tr><td>Total</td><td><span class="ob__req">✓</span></td><td></td></tr>
                <tr><td>Fecha de vencimiento</td><td><span class="ob__req">✓</span></td><td></td></tr>
              </tbody>
            </table>
          </div>
          <div class="ob__tip">Usa <strong>Generar impuestos</strong> para crear varios de una vez, igual que con las letras.</div>
        </div>
        <div class="ob__col-screen">
          <div class="ob__screen"><img src="/onboarding/07-propiedades.png" alt="Propiedades — prediales" /></div>
        </div>
      </div>

      <!-- ── 11 · Gastos ─────────────────────────────────────────── -->
      <div v-if="currentSlide === 11" class="ob__slide ob__slide--duo">
        <div class="ob__col-text">
          <div class="ob__path"><span class="ob__path-item ob__path-item--active">Gastos</span><span class="ob__path-sep">›</span><span class="ob__path-item">Nuevo gasto</span></div>
          <span class="ob__num">11 · Gastos</span>
          <h2 class="ob__heading">Los egresos operativos del negocio.</h2>
          <div class="ob__line" />
          <p class="ob__lead">En <strong>Gastos</strong> (menú lateral) registras los pagos que tú realizas: planilla, servicios, mantenimiento. El listado tiene paginación de 20 por página y puedes filtrar por fecha y estado.</p>
          <div class="ob__table-wrap">
            <table class="ob__table">
              <thead><tr><th>Campo</th><th>Req.</th><th>Notas</th></tr></thead>
              <tbody>
                <tr><td>Propiedad</td><td><span class="ob__req">✓</span></td><td>A qué local corresponde el gasto</td></tr>
                <tr><td>Tipo de gasto</td><td><span class="ob__req">✓</span></td><td>Planilla · Agua · Luz · Internet · Misceláneos</td></tr>
                <tr><td>Observación</td><td><span class="ob__req">✓</span></td><td>Descripción del gasto</td></tr>
                <tr><td>Moneda</td><td><span class="ob__req">✓</span></td><td>Soles o Dólares</td></tr>
                <tr><td>Total</td><td><span class="ob__req">✓</span></td><td>Número positivo</td></tr>
                <tr><td>Fecha de vencimiento</td><td><span class="ob__req">✓</span></td><td></td></tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="ob__col-screen">
          <div class="ob__screen"><img src="/onboarding/08-gastos.png" alt="Gastos" /></div>
        </div>
      </div>

      <!-- ── 12 · Ventas ─────────────────────────────────────────── -->
      <div v-if="currentSlide === 12" class="ob__slide ob__slide--duo">
        <div class="ob__col-text">
          <div class="ob__path"><span class="ob__path-item ob__path-item--active">Ventas</span><span class="ob__path-sep">›</span><span class="ob__path-item">Nueva venta</span></div>
          <span class="ob__num">12 · Ventas</span>
          <h2 class="ob__heading">Ventas reportadas por inquilino.</h2>
          <div class="ob__line" />
          <p class="ob__lead">En <strong>Ventas</strong> (menú lateral) registras lo que vende cada inquilino. El total se calcula automáticamente. Puedes buscar, filtrar por fecha, exportar a Excel e imprimir reportes.</p>
          <p class="ob__section-title">Datos de la venta</p>
          <div class="ob__table-wrap">
            <table class="ob__table">
              <thead><tr><th>Campo</th><th>Req.</th><th>Notas</th></tr></thead>
              <tbody>
                <tr><td>Inquilino</td><td><span class="ob__req">✓</span></td><td>Búsqueda en tiempo real por alias, nombre o local</td></tr>
                <tr><td>Moneda</td><td><span class="ob__req">✓</span></td><td>Por defecto Soles. Aplica a todos los productos</td></tr>
                <tr><td>Fecha de emisión</td><td><span class="ob__req">✓</span></td><td></td></tr>
              </tbody>
            </table>
          </div>
          <p class="ob__section-title">Productos (al menos uno)</p>
          <div class="ob__table-wrap">
            <table class="ob__table">
              <thead><tr><th>Campo</th><th>Req.</th><th>Notas</th></tr></thead>
              <tbody>
                <tr><td>Nombre del producto</td><td><span class="ob__req">✓</span></td><td></td></tr>
                <tr><td>Cantidad</td><td><span class="ob__req">✓</span></td><td></td></tr>
                <tr><td>Precio unitario</td><td><span class="ob__req">✓</span></td><td>Total por fila = Cantidad × Precio</td></tr>
              </tbody>
            </table>
          </div>
          <div class="ob__tip">El botón <strong>Guardar</strong> se activa solo cuando el total calculado es mayor a cero.</div>
        </div>
        <div class="ob__col-screen">
          <div class="ob__screen"><img src="/onboarding/09-ventas.png" alt="Ventas" /></div>
        </div>
      </div>

      <!-- ── 13 · Acceso a la app ────────────────────────────────── -->
      <div v-if="currentSlide === 13" class="ob__slide ob__slide--duo">
        <div class="ob__col-text">
          <div class="ob__path"><span class="ob__path-item ob__path-item--active">Inquilinos</span><span class="ob__path-sep">›</span><span class="ob__path-item">un inquilino</span><span class="ob__path-sep">›</span><span class="ob__path-item">Crear acceso</span></div>
          <span class="ob__num">13 · Acceso a la app móvil</span>
          <h2 class="ob__heading">Dales acceso a la app desde su celular.</h2>
          <div class="ob__line" />
          <p class="ob__lead">Desde el detalle de un inquilino en <strong>Inquilinos</strong>, puedes crear una cuenta para que consulte sus letras y ventas desde la app móvil.</p>
          <div class="ob__cols">
            <div class="ob__col ob__col--yes">
              <p class="ob__col-title">Lo que puede hacer</p>
              <ul class="ob__col-list"><li>Ver sus propias letras</li><li>Ver sus ventas del mes</li><li>Subir comprobante de pago</li></ul>
            </div>
            <div class="ob__col ob__col--no">
              <p class="ob__col-title">Lo que no puede ver</p>
              <ul class="ob__col-list"><li>Letras de otros inquilinos</li><li>Total recaudado</li><li>Gastos, prediales o arbitrios</li><li>Confirmar su propio pago</li></ul>
            </div>
          </div>
          <p class="ob__section-title">Crear acceso (primera vez)</p>
          <div class="ob__table-wrap">
            <table class="ob__table">
              <thead><tr><th>Campo</th><th>Req.</th><th>Notas</th></tr></thead>
              <tbody>
                <tr><td>Email</td><td><span class="ob__req">✓</span></td><td>Pre-cargado con el email del inquilino. Es su usuario de login</td></tr>
                <tr><td>Contraseña temporal</td><td><span class="ob__req">✓</span></td><td>Mínimo 6 caracteres. Usa <strong>Generar contraseña</strong> si quieres</td></tr>
              </tbody>
            </table>
          </div>
          <div class="ob__tip">Una vez creado, el botón cambia a <strong>Gestionar acceso</strong> donde puedes resetear la contraseña o revocar el acceso.</div>
        </div>
        <div class="ob__col-screen">
          <div class="ob__screen"><img src="/onboarding/03-inquilinos.png" alt="Acceso — inquilinos" /></div>
        </div>
      </div>

      <!-- ── 14 · Cierre ─────────────────────────────────────────── -->
      <div v-if="currentSlide === 14" class="ob__slide ob__slide--center">
        <svg class="ob__logo ob__logo--sm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 436.722 196.02" aria-label="Inqi">
          <g transform="translate(-181.639 -301.99)" fill="#B51A3E">
            <path d="M200.442,323.826a18.578,18.578,0,1,1,18.579,18.58,18.578,18.578,0,0,1-18.579-18.58"/>
            <path d="M242.222,363.76c-.627-4.154-3.625-14.423-17.971-14.423h-1.5c-2.2.039-4.938.278-5,.284l-30.847,2.936a4.942,4.942,0,0,0-1.969.822c-.08.065-.133.139-.207.207a4.5,4.5,0,0,0-1.3,2.031,9.119,9.119,0,0,0-.417,1.358c0,.017-.012.023-.012.044,0,.006,0,.006,0,.015s-.017.088-.017.088l-1.34,16.475-.009.568a3.312,3.312,0,0,0,.991,2.365,3.357,3.357,0,0,0,2.365,1.017l17.731-1.836a4.185,4.185,0,0,1,4.586,3.743l6.091,61c.751,4.6,4.21,14.987,20.283,15.162,14.023.153,16.365-8.152,16.427-13.5Z"/>
            <path d="M336.106,377.23q-4.62-3.738-12.321-3.74a33.57,33.57,0,0,0-9.679,1.32,44.848,44.848,0,0,0-8.14,3.3v77.88a43.541,43.541,0,0,1-6.16,1.21,64.762,64.762,0,0,1-8.8.55q-9.9,0-14.3-3.19t-4.4-12.431V374.15a16,16,0,0,1,2.42-9.24,26.743,26.743,0,0,1,6.82-6.6q7.038-5.058,18.15-8.14a91.712,91.712,0,0,1,24.531-3.08q23.976,0,37.068,10.56t13.092,30.14v68.2a53.11,53.11,0,0,1-6.381,1.21,64.767,64.767,0,0,1-8.8.55q-9.9,0-14.189-3.19t-4.289-12.431v-53.46Q340.727,380.972,336.106,377.23Z"/>
            <path d="M501.545,496.03a52.347,52.347,0,0,1-6.271,1.32,54.315,54.315,0,0,1-8.689.66q-9.9,0-14.3-3.3t-4.4-12.54V456.43a55.533,55.533,0,0,1-8.691,2.2,59.83,59.83,0,0,1-10.449.88,64.675,64.675,0,0,1-21.78-3.519,45.966,45.966,0,0,1-28.49-27.941,67.575,67.575,0,0,1-4.069-24.42q0-14.074,4.289-24.639a47.186,47.186,0,0,1,12.1-17.6,52.163,52.163,0,0,1,18.7-10.67,76.575,76.575,0,0,1,24.309-3.63,82.2,82.2,0,0,1,22.55,2.97q10.447,2.97,16.17,6.71a21.929,21.929,0,0,1,6.71,6.49,17.154,17.154,0,0,1,2.311,9.35Zm-47.96-63.14a28.056,28.056,0,0,0,14.519-3.74V376.79a39.927,39.927,0,0,0-5.719-2.2,26.561,26.561,0,0,0-7.92-1.1q-11.88,0-18.92,7.37t-7.04,22.769q0,15.182,6.6,22.221T453.585,432.89Z"/>
            <path d="M525.744,320.03a17.57,17.57,0,0,1,5.17-12.76q5.166-5.28,13.529-5.28t13.53,5.28a17.582,17.582,0,0,1,5.17,12.76,17.841,17.841,0,0,1-5.17,12.98q-5.171,5.28-13.53,5.28t-13.529-5.28A17.829,17.829,0,0,1,525.744,320.03Zm35.42,135.96A43.571,43.571,0,0,1,555,457.2a64.774,64.774,0,0,1-8.8.55q-9.9,0-14.191-3.19t-4.29-12.431V351.71a52.8,52.8,0,0,1,6.161-1.32,53.732,53.732,0,0,1,8.8-.66q9.9,0,14.191,3.3t4.29,12.54Z"/>
            <path d="M579.2,439.93a20.23,20.23,0,0,1,5.17-14.08q5.166-5.718,14.41-5.721,9.018,0,14.3,5.721a21.412,21.412,0,0,1,0,28.159q-5.28,5.719-14.3,5.721-9.24,0-14.41-5.721A20.214,20.214,0,0,1,579.2,439.93Z"/>
          </g>
        </svg>
        <h1 class="ob__hero-title">Ya tienes todo lo que necesitas.</h1>
        <p class="ob__hero-lead">Empieza por el <strong>Dashboard</strong> para ver qué requiere atención hoy. Puedes volver a este tutorial desde el menú lateral cuando quieras.</p>
        <button class="ob__cta" @click="finish">Ir al Dashboard</button>
      </div>

    </div>

    <!-- Nav -->
    <div class="ob__nav">
      <button v-if="currentSlide > 1" class="ob__btn ob__btn--prev" @click="prev">← Anterior</button>
      <span v-else class="ob__btn-spacer" />
      <span class="ob__counter">{{ currentSlide }} / {{ totalSlides }}</span>
      <button v-if="currentSlide < totalSlides" class="ob__btn ob__btn--next" @click="next">Siguiente →</button>
      <button v-else class="ob__btn ob__btn--next" @click="finish">Ir al Dashboard</button>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Onboarding',
  data () { return { currentSlide: 1, totalSlides: 14 } },
  methods: {
    next () { if (this.currentSlide < this.totalSlides) this.currentSlide++ },
    prev () { if (this.currentSlide > 1) this.currentSlide-- },
    goTo (n) { this.currentSlide = n },
    finish () { this.$router.push('/') }
  }
}
</script>

<style lang="scss" scoped>
$ob-bg:      #191919;
$ob-accent:  #B51A3E;
$ob-text:    #ffffff;
$ob-muted:   #8f8f8f;
$ob-border:  rgba(255, 255, 255, 0.08);
$ob-display: 'Inter Display', 'Inter', sans-serif;
$ob-base:    'Inter', sans-serif;

// ── Shell ──────────────────────────────────────────────────
.ob {
  position: fixed;
  inset: 0;
  background: $ob-bg;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  overflow: hidden;

  // ── Dots ─────────────────────────────────────────────────
  &__progress {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 16px 24px 0;
    flex-shrink: 0;
  }
  &__dot {
    width: 6px; height: 6px; border-radius: 50%;
    background: rgba(255,255,255,0.15); cursor: pointer;
    transition: all 0.2s ease;
    &--active { width: 20px; border-radius: 3px; background: $ob-accent; }
    &:hover:not(&--active) { background: rgba(255,255,255,0.35); }
  }

  // ── Stage ─────────────────────────────────────────────────
  &__stage {
    flex: 1;
    overflow: hidden;
    display: flex;
    align-items: stretch;
  }

  // ── Slide variants ────────────────────────────────────────
  &__slide {
    width: 100%;
    display: flex;

    // Portada / Cierre — centrado full
    &--center {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 40px 48px;
      overflow-y: auto;
    }

    // Contenido — dos columnas: texto | captura
    &--duo {
      display: grid;
      grid-template-columns: 420px 1fr;
    }

    // Slide conceptual sin captura — ancho moderado centrado
    &--wide {
      flex-direction: column;
      max-width: 680px;
      width: 100%;
      margin: 0 auto;
      padding: 32px 40px 24px;
      overflow-y: auto;
      &::-webkit-scrollbar { width: 3px; }
      &::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 3px; }
    }
  }

  // ── Columna texto (izquierda) ─────────────────────────────
  &__col-text {
    padding: 28px 24px 24px;
    overflow-y: auto;
    border-right: 1px solid $ob-border;
    display: flex;
    flex-direction: column;
    &::-webkit-scrollbar { width: 3px; }
    &::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 3px; }
  }

  // ── Columna captura (derecha) ─────────────────────────────
  &__col-screen {
    background: rgba(0,0,0,0.2);
    overflow-y: auto;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 20px;
    &::-webkit-scrollbar { width: 3px; }
    &::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 3px; }
  }

  // ── Screenshot ────────────────────────────────────────────
  &__screen {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid $ob-border;
    box-shadow: 0 8px 40px rgba(0,0,0,0.6);
    img { width: 100%; height: auto; display: block; }
  }

  // ── Slide 1 — elementos portada ───────────────────────────
  &__logo {
    width: 130px; height: auto; margin-bottom: 36px;
    &--sm { width: 80px; margin-bottom: 24px; }
  }
  &__hero-title {
    font-family: $ob-display;
    font-size: 2.125rem; font-weight: 600;
    color: $ob-text; letter-spacing: -0.03em; line-height: 1.1;
    margin: 0 0 14px;
  }
  &__hero-lead {
    font-family: $ob-base;
    font-size: 0.9375rem; color: $ob-muted; line-height: 1.65;
    margin: 0 0 36px; max-width: 400px;
    strong { color: rgba(255,255,255,0.8); }
  }
  &__cta {
    background: $ob-accent; color: #fff; border: none;
    border-radius: 20px; height: 44px; padding: 0 32px;
    font-family: $ob-base; font-size: 0.875rem; font-weight: 600;
    letter-spacing: 0.02em; cursor: pointer;
    transition: opacity 0.15s ease, transform 0.15s ease;
    &:hover  { opacity: 0.85; }
    &:active { transform: scale(0.97); }
  }

  // ── Labels comunes ────────────────────────────────────────
  &__path {
    display: flex; flex-wrap: wrap; align-items: center;
    gap: 4px; margin-bottom: 14px;
  }
  &__path-sep { color: rgba(255,255,255,0.2); font-size: 0.75rem; }
  &__path-item {
    font-family: $ob-base; font-size: 0.6875rem; font-weight: 500;
    color: $ob-muted;
    background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.08);
    border-radius: 4px; padding: 2px 7px;
    &--active { color: $ob-accent; background: rgba(181,26,62,0.1); border-color: rgba(181,26,62,0.25); }
  }
  &__num {
    display: block; font-family: $ob-base; font-size: 0.6875rem; font-weight: 600;
    color: $ob-accent; text-transform: uppercase; letter-spacing: 0.1em; margin-bottom: 8px;
  }
  &__heading {
    font-family: $ob-display; font-size: 1.5rem; font-weight: 600;
    color: $ob-text; letter-spacing: -0.025em; line-height: 1.15; margin: 0;
  }
  &__line {
    width: 32px; height: 2px; background: $ob-accent;
    border-radius: 1px; margin: 12px 0 18px;
  }
  &__lead {
    font-family: $ob-base; font-size: 0.875rem; color: $ob-muted;
    line-height: 1.65; margin: 0 0 20px;
    strong { color: rgba(255,255,255,0.8); font-weight: 600; }
  }
  &__sublead {
    font-family: $ob-base; font-size: 0.8125rem; color: $ob-muted; line-height: 1.5; margin: 0 0 8px;
  }
  &__section-title {
    font-family: $ob-base; font-size: 0.6875rem; font-weight: 700;
    text-transform: uppercase; letter-spacing: 0.08em;
    color: $ob-accent; margin: 18px 0 8px;
  }

  // ── Table ─────────────────────────────────────────────────
  &__table-wrap {
    overflow-x: auto; border-radius: 8px;
    border: 1px solid $ob-border; margin-bottom: 14px;
  }
  &__table {
    width: 100%; border-collapse: collapse;
    font-family: $ob-base; font-size: 0.775rem;
    thead tr { background: rgba(255,255,255,0.04); }
    th {
      text-align: left; padding: 8px 10px; color: $ob-muted;
      font-size: 0.6875rem; font-weight: 600; text-transform: uppercase;
      letter-spacing: 0.06em; white-space: nowrap;
      border-bottom: 1px solid $ob-border;
    }
    td {
      padding: 8px 10px; color: rgba(255,255,255,0.72);
      border-bottom: 1px solid $ob-border; vertical-align: middle; line-height: 1.4;
    }
    tbody tr {
      &:last-child td { border-bottom: none; }
      &:hover { background: rgba(255,255,255,0.025); }
    }
  }
  &__req { color: $ob-accent; font-weight: 700; font-size: 0.875rem; }
  &__opt { color: $ob-muted; font-size: 0.875rem; }

  // ── Badges ────────────────────────────────────────────────
  &__badge {
    display: inline-flex; align-items: center; height: 18px; padding: 0 6px;
    border-radius: 4px; font-size: 0.625rem; font-weight: 700;
    text-transform: uppercase; letter-spacing: 0.05em; margin-right: 3px;
    &--error   { background: rgba(255,60,56,0.18); color: #ff7a77; }
    &--warning { background: rgba(243,167,56,0.18); color: #F3A738; }
    &--success { background: rgba(59,178,115,0.18); color: #3BB273; }
  }

  // ── Tip ───────────────────────────────────────────────────
  &__tip {
    border-left: 3px solid $ob-accent; background: rgba(181,26,62,0.07);
    border-radius: 0 6px 6px 0; padding: 10px 12px;
    font-family: $ob-base; font-size: 0.775rem;
    color: rgba(255,255,255,0.55); line-height: 1.55; margin-top: 4px;
    strong { color: rgba(255,255,255,0.85); font-weight: 600; }
  }

  // ── Cards (slide 3) ───────────────────────────────────────
  &__cards { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
  &__card {
    display: flex; gap: 10px; align-items: flex-start;
    background: rgba(255,255,255,0.03); border: 1px solid $ob-border;
    border-radius: 8px; padding: 12px;
    transition: border-color 0.15s;
    &:hover { border-color: rgba(181,26,62,0.3); }
  }
  &__card-icon {
    flex-shrink: 0; width: 32px; height: 32px; border-radius: 7px;
    background: rgba(181,26,62,0.12); display: flex; align-items: center;
    justify-content: center; color: $ob-accent;
  }
  &__card-title {
    font-family: $ob-base; font-size: 0.775rem; font-weight: 600;
    color: $ob-text; margin: 0 0 3px; line-height: 1.3;
  }
  &__card-body {
    font-family: $ob-base; font-size: 0.725rem; color: $ob-muted;
    line-height: 1.45; margin: 0;
    strong { color: rgba(255,255,255,0.8); font-weight: 600; }
  }

  // ── Flow (slide 6) ────────────────────────────────────────
  &__flow { display: flex; flex-direction: column; gap: 4px; }
  &__flow-step {
    display: flex; align-items: flex-start; gap: 12px;
    background: rgba(255,255,255,0.03); border: 1px solid $ob-border;
    border-radius: 8px; padding: 11px 14px;
  }
  &__flow-num {
    flex-shrink: 0; width: 22px; height: 22px; border-radius: 50%;
    background: $ob-accent; color: #fff;
    font-family: $ob-base; font-size: 0.7rem; font-weight: 700;
    display: flex; align-items: center; justify-content: center;
  }
  &__flow-title { font-family: $ob-base; font-size: 0.8125rem; font-weight: 600; color: $ob-text; margin: 0 0 2px; }
  &__flow-desc  { font-family: $ob-base; font-size: 0.75rem; color: $ob-muted; margin: 0; line-height: 1.4; }
  &__flow-arrow { color: rgba(255,255,255,0.15); font-size: 0.75rem; padding-left: 11px; }

  // ── States (slide 7) ─────────────────────────────────────
  &__states { display: flex; gap: 8px; margin-bottom: 16px; }
  &__state {
    flex: 1; background: rgba(255,255,255,0.03); border: 1px solid $ob-border;
    border-radius: 8px; padding: 11px 12px;
    p { font-family: $ob-base; font-size: 0.75rem; color: $ob-muted; margin: 7px 0 0; line-height: 1.4; }
  }

  // ── Cols can/cannot (slide 13) ────────────────────────────
  &__cols { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-bottom: 16px; }
  &__col {
    border-radius: 8px; padding: 12px;
    &--yes { background: rgba(59,178,115,0.07); border: 1px solid rgba(59,178,115,0.2); }
    &--no  { background: rgba(255,60,56,0.07);  border: 1px solid rgba(255,60,56,0.18); }
  }
  &__col-title {
    font-family: $ob-base; font-size: 0.6875rem; font-weight: 700;
    text-transform: uppercase; letter-spacing: 0.07em; margin: 0 0 8px;
    .ob__col--yes & { color: #3BB273; }
    .ob__col--no  & { color: #ff7a77; }
  }
  &__col-list {
    list-style: none; margin: 0; padding: 0;
    li {
      font-family: $ob-base; font-size: 0.775rem; color: rgba(255,255,255,0.65);
      line-height: 1.4; padding: 3px 0;
      border-bottom: 1px solid rgba(255,255,255,0.05);
      &:last-child { border-bottom: none; }
      &::before { margin-right: 6px; font-size: 0.7rem; }
    }
    .ob__col--yes & li::before { content: '✓'; color: #3BB273; }
    .ob__col--no  & li::before { content: '✕'; color: #ff7a77; }
  }

  // ── Nav ───────────────────────────────────────────────────
  &__nav {
    display: flex; align-items: center; justify-content: space-between;
    padding: 12px 28px 18px; flex-shrink: 0; border-top: 1px solid $ob-border;
  }
  &__counter { font-family: $ob-base; font-size: 0.75rem; color: $ob-muted; letter-spacing: 0.04em; }
  &__btn-spacer { min-width: 112px; }
  &__btn {
    height: 38px; min-width: 112px; border-radius: 20px;
    font-family: $ob-base; font-size: 0.8125rem; font-weight: 600;
    letter-spacing: 0.02em; cursor: pointer; border: none;
    transition: opacity 0.15s ease, transform 0.15s ease;
    &:active { transform: scale(0.97); }
    &--prev {
      background: transparent; border: 1px solid rgba(255,255,255,0.12);
      color: rgba(255,255,255,0.45);
      &:hover { border-color: rgba(255,255,255,0.28); color: rgba(255,255,255,0.8); }
    }
    &--next { background: $ob-accent; color: #fff; &:hover { opacity: 0.85; } }
  }
}
</style>
